import { ClientModel } from './client.model';
import { ConstructionSiteStateEnums } from './../../enum/construction-site-enums';
export class ConstructionSiteModel {
  constructionSiteId: number = 0;
  branchId: number = 0;
  code: number = 0;
  alterCode: string | null = null;
  name: string = "";
  clientId: number = 0;
  client: ClientModel = new ClientModel();
  enterpriseId: number = 0;
  address: string | null = null;
  phone: string | null = null;
  alterPhone: string | null = null;
  email: string | null = null;
  invoiceAddress: string | null = null;
  invoicePhone: string | null = null;
  invoiceAlterPhone: string | null = null;
  invoiceEmail: string | null = null;
  conceptId: number = 0;
  zoneId: number = 0;
  sellerId: number = 0;
  swIcaRetainer: boolean = false;
  swInvoiceMonthly: boolean = true;
  originDepartmentId: number = 0;
  originCityId: number = 0;
  destinityDepartmentId: number = 0;
  destinityCityId: number = 0;
  sectorId: number | null = null;
  stateChangeDate: Date = new Date;
  constructionSiteStateId: number = ConstructionSiteStateEnums.activa;
  observation: string | null = null;
  createDate: string = "";
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
}
